import './IconSvg.scss';

import React, {CSSProperties} from 'react';

export interface IIconSvgProps {
	svg: any;
	size?: number;
	style?: CSSProperties;
	className?: string;
	viewBox?: string;
}

export class IconSvg extends React.Component<IIconSvgProps> {

	public static defaultProps = {
		size: 20,
		viewBox: '0 0 16 16'
	};

	public render() {
		const {
			className,
			size,
			style,
			svg,
			viewBox,
		} = this.props;

		const Svg = typeof svg === 'string' ? props => <img src={svg} {...props}/> : svg;
		const defaultClassNames = 'anticon icon-svg';
		const classNames = className ? (className + ' ' + defaultClassNames) : defaultClassNames;

		return <i className={classNames} style={style}>
			<Svg width={size} height={size} viewBox={viewBox}/>
		</i>;
	}
}
